import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { delete_employee_attendance, get_all_filtered_attendance, update_employee_attendance } from '../../../../app/pages/Employees/attendance/api/attendanceApi';
import { useMutation, useQuery } from 'react-query';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { KTIcon, KTSVG } from '../../../helpers';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { get_all_active_users } from './../../../../app/pages/UserManagement/users/api/usersApi';
import { formatDateOnly, formatDateWithTime, formatDateWithTime24h } from './../../../../app/helper-functions/DateFunction';
import { Attendance, AttendanceType, Shifts, User } from '../../../../app/modules/accounts/components/settings/SettingsModel';
import { add_attendance, add_employee_attendance, get_current_employee_attendance } from '../api/widgetApi';
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
type UpdateAttendanceParams = {
    id: number;
    user_id: number;
    shift_id: number;
    attendance_type_id: number;
    attendance_datetime: string;
    employee_attendance_notes:string;
};
let employee_attendance_add, employee_attendance_edit, employee_attendance_delete,employee_attendance_log,employee_attendance_view;
function AttendanceManagementList({active_attendance_type,location_shift,active_users,employee_attendance, refetch}) {
    const [searchInput, setSearchInput] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedUserId, setSelectedUserId] = useState('');
    const employeeNameRef: any = useRef();
    const [visibleData, setVisibleData] = useState<Attendance[]>([]);
    const [selectedNotes, setSelectedNotes] = useState('');
    const [ErrorNotes, setErrorNotes] = useState('');
    const [attendanceList, setAttendanceList] = useState<Attendance[]>([]);
    const [selectedAttendance, setSelectedAttendance] = useState<Attendance | null>(null);
    const [attendanceTypeList, setAttendanceTypeList] = useState<AttendanceType[]>([]);
    const [initialItemsPerPage] = useState(5); // Initial 5 records
    const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(5);
    const [showAll, setShowAll] = useState(false); // State to toggle between 5 and all records
    const [selectedUser, setSelectedUser] = useState('');
    const [filterPayload, setFilterPayload] = useState<any>({});
    const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null);
    const [selectedAttendanceType, setSelectedAttendanceType] = useState('');
    const [selectedFromDate, setSelectedFromDate] = useState<string>("");
    const [selectedToDate, setSelectedToDate] = useState<string>("");
    const [userList, setUserList] = useState<User[]>([]);
    const [selectedShiftId, setSelectedShiftId] = useState('');
    const [shiftsList, setShiftsList] = useState<Shifts[]>([]);
    const [originalAttendanceList, setOriginalAttendanceList] = useState<Attendance[]>([]);
    const navigate = useNavigate();
    const today = new Date().toISOString().slice(0, 10);

    const [selectedAttendanceTypeAdd, setSelectedAttendanceTypeAdd] = useState('');

    useEffect(() => {
        if (location_shift) {
            setShiftsList(location_shift);
        }
    }, [location_shift]);

    useEffect(() => {
        setSelectedFromDate(today);
        setSelectedToDate(today);

        if (employee_attendance && Object.keys(employee_attendance).length !== 0) {
            const filteredData = employee_attendance.filter((attendance) =>
                attendance.attendance_datetime.slice(0, 10) === today
            );

            setTimeout(() => {
                setAttendanceList(filteredData);
                setOriginalAttendanceList(filteredData);
                // Show only first 5 records initially
                setVisibleData(filteredData.slice(0, initialItemsPerPage));
            }, 0);
        } else {
            setAttendanceList([]);
            setVisibleData([]);
        }
    }, [employee_attendance]);
    useEffect(() => {
        employee_attendance_add = permissionCheck('employeeattendance-create')
        employee_attendance_edit = permissionCheck('employeeattendance-update')
        employee_attendance_delete = permissionCheck('employeeattendance-delete')
        employee_attendance_view = permissionCheck('employeeattendance-view')
        employee_attendance_log = permissionCheck('employeeattendance-activity-log')
    }, []);
    useEffect(() => {
        if (active_attendance_type) {
          if (Array.isArray(active_attendance_type)) {
            setAttendanceTypeList(active_attendance_type as AttendanceType[]);
          } else {
            // console.error('attendanceTypeData.data is not an array:', attendanceTypeData.data);
            setAttendanceTypeList([]); // Fallback to an empty array
          }
        }
      }, [active_attendance_type]);
      useEffect(() => {
        if (active_users) {
            setUserList(active_users as User[]);
        }
    }, [active_users]);
    const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    const itemsPerPageOptions = [5, 10, 20, 30, 50, 100];
    const totalItems = attendanceList.length;
    const totalPages = Math.ceil(totalItems / selectedItemsPerPage);

    useEffect(() => {
        if (attendanceList.length > 0) {
            let sortedData = [...attendanceList];
            if (sortBy) {
                sortedData.sort((a, b) => {
                    const aValue = (a[sortBy.key] || '') as string;
                    const bValue = (b[sortBy.key] || '') as string;
                    return sortBy.ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                });
            }
            
            // If showAll is true, show all records, otherwise show initial 5
            const dataToShow = showAll ? 
                sortedData.slice(
                    (currentPage - 1) * selectedItemsPerPage,
                    currentPage * selectedItemsPerPage
                ) : 
                sortedData.slice(0, initialItemsPerPage);
                
            setVisibleData(dataToShow);
        }
    }, [attendanceList, currentPage, selectedItemsPerPage, sortBy, showAll]);

    const handleViewAll = () => {
        setShowAll(true);
        setSelectedItemsPerPage(10); // Default to 10 when viewing all
    };
    const currDate = new Date();
    const mutation = useMutation(() => add_employee_attendance(selectedUserId, selectedShiftId, formatDateWithTime24h(currDate), selectedAttendanceTypeAdd, selectedNotes), {
        onSuccess: (response) => {
            toast.success(response.message, {
                position: 'top-right',
                autoClose: 3000,
            });
            // Refetch data and apply today's filter
            refetch().then(() => {
                if (employee_attendance) {
                    const filteredAttendance = employee_attendance.filter((attendance) =>
                        attendance.attendance_datetime.slice(0, 10) === today
                    );
                    setAttendanceList(filteredAttendance);
                }
            });            
            setSelectedAttendanceTypeAdd("")
            setSelectedNotes("")
            setSelectedUserId("")
            setSelectedShiftId("")
        },
        onError: (error: any) => {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                });
            } else if (error.request) {
                toast.error('No response received from the server.', {
                    position: 'top-right',
                    autoClose: 3000,
                });
            } else {
                toast.error('An unexpected error occurred.', {
                    position: 'top-right',
                    autoClose: 3000,
                });
            }
        },
    });
    const handleAddEmployee = () => {
        if (!selectedUserId) {
            toast.error('Please select an employee.', {
                position: 'top-right',
                autoClose: 3000,
            });
            return;
        }
        if (!selectedAttendanceTypeAdd) {
            toast.error('Please select an attendance type.', {
                position: 'top-right',
                autoClose: 3000,
            });
            return;
        }
        mutation.mutate();
        // Refetch data and apply today's filter
        refetch().then(() => {
            if (employee_attendance) {
                const filteredAttendance = employee_attendance.filter((attendance) =>
                    attendance.attendance_datetime.slice(0, 10) === today
                );
                setAttendanceList(filteredAttendance);
            }
        });
    };
    const toggleShowAll = () => {
    setShowAll(!showAll);
    if (!showAll) {
      setSelectedItemsPerPage(totalItems); // Show all items
    } else {
      setSelectedItemsPerPage(5); // Show only 5 items
    }
  };
    const handleInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.currentTarget.value.toLowerCase();
        setSearchInput(searchTerm);
        const filteredItems = originalAttendanceList.filter((attendance) => {
            return (
                attendance.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                attendance.shift_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                attendance.attendance_type_name?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
        setAttendanceList(filteredItems);
    }, [originalAttendanceList]);
    const { data: filterData, refetch: filterRefetch } = useQuery(
        ['filterData', filterPayload,{
            refetchOnWindowFocus: false,
          }],
        () => get_all_filtered_attendance(filterPayload),
        {
          onSuccess: (filteredData) => {
               setAttendanceList(filteredData.data);
      setOriginalAttendanceList(filteredData.data); //
      setVisibleData(filteredData.data)
          },
          onError: (error:any) => {
            if (error.response) {
              const errorMessage = error.response.data.message
              toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
              });
            }
          },
          enabled: false,
        }
    );
    useEffect(() => {
        if (Object.keys(filterPayload).length > 0) {
            filterRefetch();  // Ensure this effect triggers on filterPayload change
        }
    }, [filterPayload]);
      const handleApplyFilters = () => {
        const payload:any= {};
        if (selectedFromDate) {
            payload.date_flag = "specific";
            payload.from_date =formatDateOnly(selectedFromDate);
        }
        if (selectedToDate) {
            payload.date_flag = "specific";
            payload.to_date = formatDateOnly(selectedToDate);
        }
        if (selectedUser) {
            payload.user_flag = "specific";
            payload.user_id = selectedUser;
        }
        if (selectedAttendanceType) {
            payload.attendance_type_flag = "specific";
            payload.attendance_type_id = selectedAttendanceType;
        }
        setFilterPayload(payload);
    };
    const handleClearFilters = () => {
        setSelectedAttendanceType('');
        setSelectedFromDate("");
        setSelectedToDate("");
        setSelectedUser('');
        setFilterPayload({});  // Clear the filter payload
        employeeNameRef.current.clearValue();
        if (employee_attendance) {
            // Filter attendance records to show only today's attendance
            const filteredAttendance = employee_attendance.filter((attendance) => {
                // Extract date from attendance_datetime
                const attendanceDate = attendance.attendance_datetime.slice(0, 10);
                return attendanceDate === today;
            });
            // Set the filtered attendance list
            setAttendanceList(filteredAttendance);
            setOriginalAttendanceList(filteredAttendance); // Store filtered list as original
        }
    };
     const handleSort = (key: string) => {
        if (sortBy && sortBy.key === key) {
            setSortBy({ key, ascending: !sortBy.ascending });
        } else {
            setSortBy({ key, ascending: true });
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
// Add react-select for searchable dropdown
   const employeeOptions = userList.map(user => ({
    value: user.id,
    label: user.full_name
}));

    return (
        <div className='card mb-5 mb-xl-10'>
        {/* Card Title */}
        <div className='card-header border-0 pt-5'>
            <div className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Employee Attendance</span>
                <span className='text-muted fw-bold fs-7'>Showing {showAll ? 'all' : 'recent'} attendance records</span>
            </div>
        </div>

        {/* Filter Section */}
        <div className='card-header border-0 pt-0 pb-5'>
            <div className='row gx-4 gy-4'>
                <div className='col-12'>
                    <h5 className='mb-2 fw-semibold text-gray-700'>Filter by:</h5>
                </div>

                <div className='col-md-3'>
                    <label className='form-label fw-semibold'>From Date</label>
                    <DatePicker
                        className='form-control form-control-lg form-control-solid'
                        placeholderText='Select From Date'
                        dateFormat='dd-MM-yyyy'
                        selected={selectedFromDate}
                        onChange={(date) => setSelectedFromDate(formatDateOnly(date))}
                    />
                </div>

                <div className='col-md-3'>
                    <label className='form-label fw-semibold'>To Date</label>
                    <DatePicker
                        className='form-control form-control-lg form-control-solid'
                        placeholderText='Select To Date'
                        selected={selectedToDate}
                        dateFormat='dd-MM-yyyy'
                        onChange={(date) => setSelectedToDate(formatDateOnly(date))}
                    />
                </div>

                <div className='col-md-3'>
                    <label className='form-label fw-semibold'>Employee</label>
                    <Select
                        ref={employeeNameRef}
                        options={employeeOptions}
                        value={employeeOptions.find(option => option.value.toString() === selectedUser)}
                        onChange={(selectedOption) => setSelectedUser(selectedOption ? selectedOption.value.toString() : '')}
                        isClearable
                        placeholder='Select Employee...'
                    />
                </div>

                <div className='col-md-3'>
                    <label className='form-label fw-semibold'>Attendance Type</label>
                    <select
                        className='form-select form-select-solid form-select-lg fw-semibold'
                        value={selectedAttendanceType}
                        onChange={(e) => setSelectedAttendanceType(e.target.value)}
                    >
                        <option value=''>Select Attendance Type...</option>
                        {Array.isArray(attendanceTypeList) && attendanceTypeList.length > 0 ? (
                            attendanceTypeList.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.title}
                                </option>
                            ))
                        ) : (
                            <option value='' disabled>No Attendance Types Available</option>
                        )}
                    </select>
                </div>

                <div className='col-12 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-end mt-4'>
                    <div className='position-relative mb-3 mb-md-0'>
                        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-4 mt-2 text-gray-500' />
                        <input
                            type='text'
                            className='form-control form-control-solid ps-14 w-100 w-md-250px'
                            placeholder='Search Attendance'
                            value={searchInput}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className='d-flex gap-3'>
                        <button className='btn btn-primary' onClick={handleApplyFilters}>
                            Apply Filters
                        </button>
                        <button className='btn btn-light-danger' onClick={handleClearFilters}>
                            Clear Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div className='card-body py-3'>
            <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                        <tr className='fw-bold text-muted bg-light'>
                            <th className='min-w-150px'>Employee Name</th>
                            <th className='min-w-150px'>Attendance Type</th>
                            <th className='min-w-120px'>Time</th>
                            <th className='min-w-120px'>Shift</th>
                            <th className='min-w-120px'>Updated By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleData.length > 0 ? (
                            visibleData.map((attendance: any) => (
                                <tr key={attendance.id}>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <div className='symbol symbol-45px me-5'>
                                                <span className='symbol-label bg-light-primary'>
                                                    <KTIcon iconName='user' className='fs-2x text-primary' />
                                                </span>
                                            </div>
                                            <div className='d-flex justify-content-start flex-column'>
                                                <span className='text-dark fw-bold fs-6'>
                                                    {attendance.user_name}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`badge badge-light-${attendance.attendance_type_name === 'Present' ? 'success' : 'danger'} fs-7 fw-bold`}>
                                            {attendance.attendance_type_name}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-muted fw-bold d-block fs-7'>
                                            {formatDateWithTime(attendance.attendance_datetime)}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bold d-block fs-7'>
                                            {attendance.shift_name}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-muted fw-bold d-block fs-7'>
                                            {attendance.updated_by_name}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className='text-center py-10'>
                                    <div className='d-flex flex-column align-items-center'>
                                        <KTIcon iconName='information-5' className='fs-2x text-gray-400 mb-2' />
                                        <span className='text-muted fw-bold fs-4'>No attendance records found</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>       
               <div className='card-footer d-flex justify-content-between align-items-center py-4'>
                 <div className='d-flex align-items-center'>
                   <select
                     className='form-select form-select-sm form-select-solid w-75px me-3'
                     value={selectedItemsPerPage}
                     onChange={(e) => {
                       setSelectedItemsPerPage(Number(e.target.value));
                       setShowAll(Number(e.target.value) === totalItems);
                     }}
                   >
                     {itemsPerPageOptions.map(option => (
                       <option key={option} value={option}>{option}</option>
                     ))}
                   </select>
                   <span className='text-muted'>Showing {showAll ? totalItems : Math.min(5, totalItems)} of {totalItems} records</span>
                 </div>
                 
                 <div className='d-flex'>
                   {!showAll && totalItems > 5 && (
                     <button
                       className='btn btn-sm btn-primary'
                       onClick={toggleShowAll}
                     >
                       <KTIcon iconName='arrow-down' className='fs-2' /> View All
                     </button>
                   )}
                   {showAll && totalItems > 5 && (
                     <button
                       className='btn btn-sm btn-light-primary'
                       onClick={toggleShowAll}
                     >
                       <KTIcon iconName='arrow-up' className='fs-2' /> Show Less
                     </button>
                   )}
                 </div>
               </div>
        </div>
    </div>

    )
}
export default AttendanceManagementList;
